import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  constructor() { }
  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }


  getRandomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }
  getRandomNumber(length) {
    var randomChars = '0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }
  getEncode(param) {
    var result = btoa(param)
    return result;
  }
  getDecode(param) {
    var result = atob(param)
    return result;
  }
  validateTruefalse(value) {
    if (value == true) {
      value = 1;
    }
    if (value == false) {
      value = 0;
    }
    return value;
  }
  validateYesNo(value) {
    if (value == true) {
      value = "Yes";
    }
    if (value == false) {
      value = "No";
    }
    return value;
  }
  validateZeroOne(value) {
    if (value == 1) {
      value = true;
    }
    if (value == 0) {
      value = false;
    }
    return value;
  }
  timepassed(dateCreated) {
    let date_now = new Date().getTime();
    let date_future = new Date(dateCreated).getTime();

    var delta = Math.abs(date_future - date_now) / 1000;

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    var seconds = delta % 60;  // in theory the modulus is not required
  }
  crypt = (text: any) => {
    let salt = 'Misafe@2021'
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const byteHex = n => ('0' + Number(n).toString(16));
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return text
      .split('')
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join('');
  };
  decrypt = (encoded: any) => {
    let salt = 'Misafe@2021'
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
      .match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
  };


}
